export default {
    getPages: state => state.pages,
    getPage: state => state.page,
    getLoading: state => state.loading,
}